<template>
  <div class="box">
    <h3 class="title has-text-grey">{{ estrategia.name }}</h3>
    <hr />
    <h3 class="title has-text-grey">Inscripción:</h3>
    <form @submit.prevent="inscribir">
      <div class="field is-horizontal">
        <div class="field-body">
          <div class="field">
            <label class="label">Nº documento de identidad</label>
            <div class="control has-icons-left">
              <input
                class="input has-text-right"
                type="number"
                required="required"
                min="1"
                value="cedula"
                autofocus="true"
                v-model="numeroDoc"
                :disabled="consultando"
              />

              <span class="icon is-left">
                <i class="far fa-id-badge"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'documento' in errores">
              <span v-for="error in errores.documento" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
          <div class="field">
            <label class="label">Fecha de nacimiento</label>
            <div class="control has-icons-left">
              <input
                class="input has-text-right"
                type="date"
                required="required"
                value="fechaNacimientoIngresada"
                v-model="birthday"
                :disabled="consultando"
              />
              <span class="icon is-left">
                <i class="far fa-calendar-alt"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'fecha_nacimiento' in errores">
              <span v-for="error in errores.fecha_nacimiento" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-body">
          <div class="field">
            <label class="label">Primer Apellido</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                value="dbPrimerApellido"
                v-model="primerApellido"
                :disabled="consultando"
                required="required"
              />
              <span class="icon is-left">
                <i class="fas fa-address-book"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'primer_apellido' in errores">
              <span v-for="error in errores.primer_apellido" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
          <div class="field">
            <label class="label">Segundo Apellido</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                value="dbSegundoApellido"
                v-model="segundoApellido"
                :disabled="consultando"
              />
              <span class="icon is-left">
                <i class="fas fa-address-book"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'segundo_apellido' in errores">
              <span v-for="error in errores.segundo_apellido" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-body">
          <div class="field">
            <label class="label">Primer Nombre</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                v-model="primerNombre"
                value="dbPrimerNombre"
                :disabled="consultando"
                required="required"
              />
              <span class="icon is-left">
                <i class="fas fa-address-book"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'primer_nombre' in errores">
              <span v-for="error in errores.primer_nombre" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
          <div class="field">
            <label class="label">Segundo Nombre</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                v-model="segundoNombre"
                value="dbSegundoNombre"
                :disabled="consultando"
              />
              <span class="icon is-left">
                <i class="fas fa-address-book"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'segundo_nombre' in errores">
              <span v-for="error in errores.segundo_nombre" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Dirección, Corregimiento o Vereda</label>
        <div class="control has-icons-left">
          <input
            class="input"
            type="text"
            v-model="direccionIngresada"
            placeholder="dirección de residencia"
          />
          <span class="icon is-left">
            <i class="fas fa-map-marker-alt"></i>
          </span>
        </div>
      </div>

      <label class="label">Celular</label>
      <div class="field has-addons">
        <div class="control has-icons-left">
          <span class="select">
            <select v-model="codigoSeleccionado" :disabled="consultando">
              <option
                v-for="codigo in codigos"
                :key="codigo.pais"
                :value="codigo.code"
              >
                {{ codigo.code }} - {{ codigo.pais }}
              </option>
            </select>
          </span>
          <span class="icon is-small is-left">
            <i class="fas fa-globe"></i>
          </span>
        </div>
        <div class="control has-icons-left is-expanded">
          <input
            class="input has-text-right"
            type="number"
            v-model="newCelular"
            :disabled="consultando"
          />
          <span class="icon is-small is-left">
            <i class="fas fa-phone"></i>
          </span>
          <p class="help is-danger" v-if="'celular' in errores">
            <span v-for="error in errores.celular" :key="error">
              *{{ error }}
            </span>
          </p>
        </div>
      </div>

      <div class="field">
        <label class="label">E-Mail</label>
        <div class="control has-icons-left">
          <input
            class="input"
            type="email"
            v-model="newEmail"
            :disabled="consultando"
            required="required"
          />
          <span class="icon is-left">
            <i class="fas fa-envelope"></i>
          </span>
        </div>
        <p class="help is-danger" v-if="'email' in errores">
          <span v-for="error in errores.email" :key="error">*{{ error }}</span>
        </p>
      </div>

      <div class="field">
        <label class="label">Género:</label>
        <div class="control has-icons-left is-expanded">
          <span class="select is-fullwidth">
            <select
              v-model="generoSeleccionado"
              ref="select_diplomados"
              required="required"
            >
              <option disabled value="">Seleccione su género</option>
              <option
                v-for="genero in generos"
                :key="genero.id"
                :value="genero.id"
              >
                {{ genero.name }}
              </option>
            </select>
          </span>
          <span class="icon is-small is-left">
            <i class="fas fa-venus-mars"></i>
          </span>
        </div>
        <p class="help is-danger" v-if="'genero' in errores">
          <span v-for="error in errores.genero" :key="error">*{{ error }}</span>
        </p>
      </div>

      <div class="field is-horizontal">
        <div class="field-body">
          <div class="field">
            <label class="label">Departamento</label>
            <div class="control has-icons-left is-expanded">
              <span class="select is-fullwidth">
                <select
                  v-model="departamentoSeleccionado"
                  required="required"
                  :disabled="consultando"
                >
                  <option disabled value="">Seleccione un departamento</option>
                  <option
                    v-for="departamento in departamentos"
                    :key="departamento.id"
                    :value="departamento.id"
                  >
                    {{ departamento.nombre }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <i class="fas fa-map-marked-alt"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <label class="label">Municipio</label>
            <div class="control has-icons-left is-expanded">
              <span class="select is-fullwidth">
                <select
                  v-model="municipioSeleccionado"
                  required="required"
                  :disabled="consultando"
                >
                  <option
                    v-for="municipio in municipios"
                    :key="municipio.id"
                    :value="municipio.id"
                  >
                    {{ municipio.nombre }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <!-- <i style="color: black" class="fas fa-graduation-cap"></i> -->
                <i class="fas fa-map-marked-alt"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="'municipio' in errores">
              <span v-for="error in errores.municipio" :key="error">
                *{{ error }}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Institución Educativa</label>
        <v-select
          v-if="sedes"
          v-model="sedeSeleccionada"
          label="sede"
          :options="sedes"
          required="required"
          :disabled="consultando"
        >
          <template #search="{ attributes, events }">
            <input
              class="vs__search"
              :required="!sedeSeleccionada"
              v-bind="attributes"
              v-on="events"
            />
          </template>
          <template #option="{ sede, ie }">
            <h3 style="margin: 0">{{ sede }}</h3>
            <em style="font-size: 9pt">{{ ie }}</em>
          </template>
        </v-select>
      </div>
      <!-- <div class="field">
                <label class="label">Institución Educativa</label>
                <div class="control has-icons-left is-expanded">
                    <span class="select is-fullwidth">
                        <select
                            v-model="sedeSeleccionada"
                            ref="select_diplomados"
                            required="required"
                            :disabled="consultando"
                        >
                            <option
                                v-for="sede in sedes"
                                :key="sede.id"
                                :value="sede.id"
                            >
                                {{ sede.ie }} - {{ sede.sede }}
                            </option>
                        </select>
                    </span>
                    <span class="icon is-small is-left">
                        <i class="fas fa-graduation-cap"></i>
                    </span>
                </div>
                <p class="help is-danger" v-if="'descripcion' in errores">
                    *{{ errores.descripcion }}
                </p>
      </div>-->
      <!--  -->

      <div class="field">
        <label class="label">Oferta</label>
        <div class="control has-icons-left is-expanded">
          <span class="select is-fullwidth">
            <select
              v-model="diplomadoSeleccionado"
              ref="select_diplomados"
              :disabled="consultando"
            >
              <option
                v-for="diplomado in diplomados"
                :key="diplomado.id"
                :value="diplomado.id"
              >
                {{ diplomado.name }}
                {{ diplomado.year ? "-" : "" }}
                {{ diplomado.year }}
              </option>
            </select>
          </span>
          <span class="icon is-small is-left">
            <i class="fas fa-graduation-cap"></i>
          </span>
        </div>
        <p class="help is-danger" v-if="'descripcion' in errores">
          *{{ errores.descripcion }}
        </p>
      </div>
      <div v-if="camposAdicionales.length">
        <hr />
        <label class="label">Campos adicionales</label>
        <div class="field" v-for="campo in camposAdicionales" :key="campo.id">
          <label class="label">{{ campo.nombre }}</label>
          <div v-if="campo.tipo == 'combobox'" class="control is-expanded">
            <multi-select
              :campo="campo"
              v-model="valoresCamposAdicionales[`${campo.nombre}`]"
            />
          </div>
        </div>
      </div>
      <hr />

      <div class="field">
        <label class="label">Área a la que pertenece</label>
        <div class="control has-icons-left is-expanded">
          <span class="select is-fullwidth">
            <select v-model="areaSeleccionada" required="required">
              <option v-for="area in areas" :key="area.id" :value="area.nombre">
                {{ area.nombre }}
              </option>
            </select>
          </span>
          <span class="icon is-small is-left">
            <i class="fas fa-book-reader"></i>
          </span>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-body">
          <div class="field">
            <label class="label">Tipo de vinculación:</label>
            <div class="control has-icons-left">
              <span class="select is-fullwidth">
                <select v-model="tipoSeleccionado" required="required">
                  <option disabled value="">Seleccione un tipo</option>
                  <option
                    v-for="tipo in tipos"
                    :key="tipo.id"
                    :value="tipo.nombre"
                  >
                    {{ tipo.nombre }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <i class="fas fa-file-contract"></i>
              </span>
            </div>
          </div>

          <div class="field">
            <label class="label">Nivel al que pertenece:</label>
            <div class="control has-icons-left">
              <span class="select is-fullwidth">
                <select v-model="nivelSelccionado" required="required">
                  <option disabled value="">Seleccione un nivel</option>
                  <option
                    v-for="nivel in niveles"
                    :key="nivel.id"
                    :value="nivel.nombre"
                  >
                    {{ nivel.nombre }}
                  </option>
                </select>
              </span>
              <span class="icon is-small is-left">
                <i class="fas fa-sort-amount-up-alt"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Carta</label>
        <div
          class="file is-medium has-name is-boxed is-expanded is-fullwidth"
          :class="{ 'is-success': file1Name }"
        >
          <label class="file-label">
            <input
              class="file-input"
              id="file1"
              ref="file1"
              @change="selectCarta()"
              type="file"
              name="file1"
              accept="application/pdf"
            />
            <span class="file-cta">
              <span class="file-icon">
                <i class="fas fa-upload"></i>
              </span>
            </span>
            <span v-if="file1Name" class="file-name">
              {{ file1Name }}
            </span>
            <span v-else class="file-name">Seleccione un archivo...</span>
          </label>
        </div>
        <!-- <p class="help is-danger" v-if="'file2' in errores">
                    <span v-for="error in errores.file2" :key="error"
                        >*{{ error }}
                    </span>
        </p>-->
      </div>

      <div>
        <input type="checkbox" id="checkbox" v-model="habilitarsubmit" />
        <label for="checkbox">
          Autorizo la política de tratamiendo de datos personales.
        </label>
        <a
          href="https://www.computadoresparaeducar.gov.co/publicaciones/66/politicas-y-condiciones-de-uso/"
          target="_blank"
        >
          <b><u>Ver</u></b>
        </a>
      </div>

      <div class="field is-grouped is-grouped-right">
        <div class="control">
          <button
            id="btnInscribir"
            type="submit"
            class="button is-block is-info"
            :class="{ 'is-loading': consultando }"
            :disabled="consultando || !habilitarsubmit"
          >
            Inscribir
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import MultiSelect from "./Inputs/MultiSelect";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "axios";
import { mapGetters } from "vuex";
import _ from "lodash";
import {
  diplomadosDisponibles,
  preInscribir,
  cargos,
  tiposDocumento,
  departamentos,
  municipiosDepartamento,
  detalleMunicipio,
  sedesMunicipio,
  camposAdicionales,
  generos
} from "../api";
export default {
  name: "formulario-inscripcion-2",
  components: { MultiSelect, vSelect },
  data: function () {
    return {
      departamentos: [],
      municipios: [],
      camposAdicionales: [],
      valoresCamposAdicionales: {},
      generos: [],
      generoSeleccionado: "",
      departamentoSeleccionado: null,
      municipioSeleccionado: null,
      sedeSeleccionada: null,
      detalleMunicipio: null,
      primerApellido: null,
      segundoApellido: null,
      primerNombre: null,
      segundoNombre: null,
      codigoSeleccionado: "",
      numeroDoc: null,
      tipoSeleccionado: "",
      nivelSelccionado: "",
      direccionIngresada: "",
      areaSeleccionada: "",
      birthday: "",
      habilitarsubmit: false,
      fileCarta: null,
      file1: "",
      codigos: [
        { pais: "Colombia", code: "+57" },
        { pais: "Venezuela", code: "+58" },
        { pais: "Panamá", code: "+507" },
        { pais: "Brasil", code: "+55" },
        { pais: "Perú", code: "+51" },
        { pais: "Ecuador", code: "+593" },
        { pais: "Bolivia", code: "+591" },
        { pais: "Paraguay", code: "+595" },
        { pais: "Uruguay", code: "+598" },
        { pais: "México", code: "+52" },
        { pais: "Costa Rica", code: "+506" },
        { pais: "Cuba", code: "+53" },
        { pais: "Guatemala", code: "+502" },
        { pais: "Honduras", code: "+504" },
        { pais: "Jamaica", code: "+876" },
        { pais: "Nicaragua", code: "+505" },
        { pais: "Puerto Rico", code: "+1787" },
        { pais: "Rep. Dominicana", code: "+809" }
      ],
      areas: [
        { nombre: "Matemáticas" },
        { nombre: "Humanidades (Lengua castellana/Idiomas extranjeros)" },
        { nombre: "Ciencias (Sociales/Historia/Constitución Política)" },
        { nombre: "Ciencias (Naturales/Educación Ambiental)" },
        { nombre: "Tecnología e Informática" },
        { nombre: "Educación artística y cultural" },
        { nombre: "Educación física, recreación y deportes" },
        { nombre: "Otra" }
      ],
      niveles: [
        { nombre: "Preescolar" },
        { nombre: "Básica Primaria" },
        { nombre: "Básica Secundaria" },
        { nombre: "Media" },
        { nombre: "Superior" }
      ],
      tipos: [{ nombre: "Carrera" }, { nombre: "Provisional" }],
      errores: {},
      cargos: [],
      tiposDoc: [],
      newEmail: "",
      newCelular: "",
      consultando: false,
      diplomadoSeleccionado: null,
      diplomados: [{ id: 0, name: "Cargando...", year: null }],
      sedes: null,
      cel: false
    };
  },
  computed: {
    file1Name() {
      return this.file1 ? this.file1.name : null;
    },
    ...mapGetters({
      estrategia: "getEstrategia"
    }),
    cedula: function () {
      return this.$store.getters.cedula;
    },
    fechaNacimientoIngresada: function () {
      return this.$store.getters.fechaNacimiento;
    },
    datosCPE: function () {
      return this.$store.getters.getDatosCPE;
    },
    datosMEN: function () {
      return this.$store.getters.getDatosMEN;
    },
    datos: function () {
      if (Object.keys(this.datosCPE).length === 0) {
        return this.datosMEN;
      } else {
        return this.datosCPE;
      }
    },
    dbPrimerApellido() {
      let pa;
      pa = " ";
      return this.datos.primer_apellido == null
        ? pa
        : this.datos.primer_apellido;
      //return this.datos.primer_apellido;
    },
    dbSegundoApellido() {
      let sa;
      sa = " ";
      return this.datos.segundo_apellido == null
        ? sa
        : this.datos.segundo_apellido;
      //return this.datos.segundo_apellido;
    },
    dbPrimerNombre() {
      let pn;
      pn = "";
      return this.datos.primer_nombre === null ? pn : this.datos.primer_nombre;
      //return this.datos.primer_nombre;
    },
    dbSegundoNombre() {
      let sn;
      sn = " ";
      return this.datos.segundo_nombre == null ? sn : this.datos.segundo_nombre;
      //return this.datos.segundo_nombre;
    },
    celular() {
      let celular;
      celular = 0;
      return this.datos.celular === null ? celular : this.datos.celular;
      //return this.datos.celular ? null : celular;
    },
    cargo() {
      let cargo;
      cargo = _.find(this.cargos, ["id", this.datos.cargo]);
      return cargo ? cargo.name : "Cargando...";
    },
    email() {
      let email;
      email = "";
      return this.datos.email === null ? email : this.datos.email;
      //return this.datos.email ? null : email;
    },
    tipoId() {
      let tipo_documento;
      tipo_documento = _.find(this.tiposDoc, ["id", this.datos.tipo_documento]);
      return tipo_documento ? tipo_documento.name : "Cargando...";
    }
  },
  methods: {
    checkcel() {
      if (!(this.newCelular.length === 10)) {
        this.cel = false;
        alert("Número de celular inválido.");
      } else this.cel = true;
    },
    selectCarta() {
      console.log("Manejador file carta");
      this.file1 = this.$refs.file1.files[0];
      console.log("carta: " + this.file1);
    },
    salir() {
      this.$globalEventBus.$emit("salir");
    },
    inscribir() {
      this.checkcel();
      if (this.camposAdicionales.length > 0) {
        if (
          !(
            this.valoresCamposAdicionales.tematica.length >= 2 &&
            this.valoresCamposAdicionales.tematica.length <= 2
          )
        ) {
          alert("El campo temática es obligatorio");
          return;
        }
      }

      if (this.cel == true) {
        this.errores = {};
        this.consultando = true;
        // console.log("archivo antes del post: " + this.file1);
        axios
          .post(preInscribir(), this.datosenvair())
          .then((response) => {
            console.log(response);
            // alert("Docente Inscrito");

            alert("La inscripción se ha realizado correctamente");
            this.salir();
          })
          .catch(error => {
            console.log("Error");
            // alert("Ocurrio un error");
            console.log(error);
            console.log(error.response);
            switch (error.response.status) {
              case 400:
                break;
              case 406:
                this.errores = error.response.data;
                break;
              default:
                break;
            }
          })
          .then(() => {
            this.consultando = false;
            // alert("Operacion completada");
          });
      }
    },
    fetchDiplomados: function () {
      this.consultando = true;
      axios
        .get(diplomadosDisponibles())
        .then(response => {
          // console.log(response);
          this.diplomados = response.data.results;
        })
        .catch(error => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchCargos: function () {
      this.consultando = true;
      axios
        .get(cargos)
        .then(response => {
          // console.log(response);
          this.cargos = response.data.results;
        })
        .catch(error => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchDptos() {
      this.consultando = true;
      axios
        .get(departamentos)
        .then(response => {
          // console.log(response);
          this.departamentos = response.data.results;
        })
        .catch(error => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchMunicipios(departamentoId) {
      this.consultando = true;
      axios
        .get(municipiosDepartamento(departamentoId))
        .then(response => {
          // console.log(response);
          this.municipios = response.data.results;
          this.sedeSeleccionada = null;
          // this.sedes = null;
        })
        .catch(error => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchSedes(municipioId) {
      this.consultando = true;
      axios
        .get(sedesMunicipio(municipioId))
        .then(response => {
          // console.log(response);
          // this.sedes = response.data.results;
          this.sedes = response.data.results;
        })
        .catch(error => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchDetalleMunicipio(id) {
      this.consultando = true;
      axios
        .get(detalleMunicipio(id))
        .then(response => {
          // console.log(response);
          this.detalleMunicipio = response.data;
          // this.departamentoSeleccionado = this.detalleMunicipio.departamento;
          // this.municipioSeleccionado = id;
        })
        .catch(error => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchTipoDoc: function () {
      this.consultando = true;
      axios
        .get(tiposDocumento)
        .then(response => {
          //console.log("tipo de documento "+ response.data + "linea 855");
          this.tiposDoc = response.data.results;
        })
        .catch(error => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    seleccionarPrimero() {
      // this.$refs.select_diplomados.selectedIndex = 0;
      this.diplomadoSeleccionado = this.diplomados[0].id;
    },
    dividirNumero() {
      var codigo = "",
        telefono = "";
      if (this.celular.length > 10) {
        codigo = this.celular.slice(0, this.celular.length - 10);
        telefono = this.celular.slice(
          this.celular.length - 10,
          this.celular.length
        );
        this.codigoSeleccionado = codigo;
        this.newCelular = telefono;
      }
    },

    fetchGeneros() {
      this.consultando = true;
      axios
        .get(generos)
        .then(response => {
          // console.log(response);
          this.generos = response.data.results;
        })
        .catch(error => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },
    fetchCamposAdicionales() {
      this.consultando = true;
      console.log(camposAdicionales());
      axios
        .get(camposAdicionales())
        .then(response => {
          this.camposAdicionales = Object.keys(response.data).length > 0 ? response.data : [];
          this.camposAdicionales.forEach(campo => {
            // let obj = {};
            // obj[`${campo.nombre}`] = [];
            this.$set(this.valoresCamposAdicionales, `${campo.nombre}`, []);
            // this.valoresCamposAdicionales[`${campo.nombre}`] = [];
          });
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.consultando = false;
        });
    },

    datosenvair() {
      var formData = null;
      formData = new FormData();
      formData.append("documento", this.cedula);
      formData.append("diplomado", this.diplomadoSeleccionado);
      formData.append("fecha_nacimiento", this.birthday);
      formData.append("celular", this.codigoSeleccionado + this.newCelular);
      formData.append("email", this.newEmail);
      formData.append("municipio", this.municipioSeleccionado);
      formData.append("campos_adicionales", {
        ...this.valoresCamposAdicionales,
        ...{ radicado_id: this.sedeSeleccionada.id }
      });
      formData.append("Apellido1", this.primerApellido);
      formData.append("Apellido2", this.segundoApellido);
      formData.append("Nombre1", this.primerNombre);
      formData.append("Nombre2", this.segundoNombre);
      formData.append("direccion", this.direccionIngresada);
      formData.append("genero", this.generoSeleccionado);
      formData.append("area", this.areaSeleccionada);
      formData.append("vinculacion", this.tipoSeleccionado);
      formData.append("nivel", this.nivelSelccionado);
      formData.append("sede", this.sedeSeleccionada.id);
      //formData.append("tipo_documento", this.tipoDocSeleccionado);
      formData.append("file", this.file1);

      return formData;
    }
  },
  mounted() {
    console.log(sedesMunicipio(5));

    this.fetchCamposAdicionales();
    this.municipioSeleccionado = this.datos.municipio;
    this.fetchDptos();
    this.fetchDetalleMunicipio(this.datos.municipio);
    this.seleccionarPrimero();
    this.fetchDiplomados();
    this.fetchCargos();
    this.fetchGeneros();
    this.fetchTipoDoc();
    this.dividirNumero();
    //this.fetchSedes(this.datos.municipio);
    this.newEmail = this.email;
    this.areaSeleccionada = this.area;
    this.primerApellido = this.dbPrimerApellido;
    this.segundoApellido = this.dbSegundoApellido;
    this.primerNombre = this.dbPrimerNombre;
    this.segundoNombre = this.dbSegundoNombre;
    this.numeroDoc = this.cedula;
    this.birthday = this.fechaNacimientoIngresada;
  },
  watch: {
    diplomados() {
      this.diplomadoSeleccionado = this.diplomados[0].id;
    },
    departamentoSeleccionado: function (departamentoId) {
      // this.municipioSeleccionado = null;
      this.fetchMunicipios(departamentoId);
    },
    municipioSeleccionado: function (municipioId) {
      // this.municipioSeleccionado = null;
      this.fetchSedes(municipioId);
    }
  }
};
</script>

<style></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
